import {
	StyleSettingsCarouselUploaderContext,
	IStyleSettingsCarouselUploaderContext,
} from '../../styleSettingsCarouselUploaderState/styleSettingsCarouselUploaderContext';
import React, { useContext } from 'react';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import classNames from 'classnames';
import style from './ErrorModals.module.scss';

interface IErrorModals {
	imageMaxFileSizeMB?: number;
	videoMaxFileSizeMB?: number;
	pdfMaxFileSizeMB?: number;
}

const ErrorModals: React.FC<IErrorModals> = ({ imageMaxFileSizeMB, videoMaxFileSizeMB, pdfMaxFileSizeMB }) => {
	const { changeTypeOfErrorModalWindow, typeOfErrorModalWindow } = useContext<IStyleSettingsCarouselUploaderContext>(
		StyleSettingsCarouselUploaderContext,
	);

	const containerClasses = classNames(style.container, { [style.visible]: typeOfErrorModalWindow });

	const handleCloseModal = () => {
		changeTypeOfErrorModalWindow(null);
	};

	return (
		<div className={containerClasses} data-test="ModalWindows">
			<ModalSentError
				onConsentEvent={handleCloseModal}
				isVisible={typeOfErrorModalWindow === 'imageFileSizeExceeded'}
				description="fileSizeExceeded"
				translationOptions={{ size: `${imageMaxFileSizeMB}MB` }}
			/>
			<ModalSentError
				onConsentEvent={handleCloseModal}
				isVisible={typeOfErrorModalWindow === 'videoFileSizeExceeded'}
				description="fileSizeExceeded"
				translationOptions={{ size: `${videoMaxFileSizeMB}MB` }}
			/>
			<ModalSentError
				onConsentEvent={handleCloseModal}
				isVisible={typeOfErrorModalWindow === 'pdfFileSizeExceeded'}
				description="fileSizeExceeded"
				translationOptions={{ size: `${pdfMaxFileSizeMB}MB` }}
			/>
			<ModalSentError
				onConsentEvent={handleCloseModal}
				isVisible={typeOfErrorModalWindow === 'fileUploadError'}
				description="fileUploadError"
			/>
			<ModalSentError
				onConsentEvent={handleCloseModal}
				isVisible={typeOfErrorModalWindow === 'invalidFileFormat'}
				description="invalidFileFormatPhotoVideo"
				translationOptions={{ photoFormats: '.jpeg, .jpg, .png', videoFormats: '.mp4' }}
			/>
		</div>
	);
};

export default ErrorModals;
